import PropTypes from 'prop-types';
import { TitleWrapper } from './Title.styled';

const Title = ({ title, context }) => {
  return (
    <TitleWrapper data-testid={`test_title_${context}`}>{title}</TitleWrapper>
  );
};

Title.propTypes = {
  title: PropTypes.string,
  context: PropTypes.string,
};

export default Title;
